import { PositionsTable } from '@root/features/trade/position/positions-table'

type AnalyticsViewProps = {}

export const PositionsViewTable: React.FC<AnalyticsViewProps> = () => {
  return <PositionsTable />
}
